

export const getReasonList = (page, limit, search) => onResponse => {
  

};
export const createReason = (client, incompletestatus) => onResponse => {
 

};
export const updateReason = (client, id, status) => onResponse => {
   
};
export const getSingleReasonDetail = (status_data) => onResponse => {
  

};
export const getReasonsDropdown = (client) => onResponse => {
  

};
export const getDeleteIncomplete = (id) => onResponse => {
  

};

